module.exports = __webpack_public_path__ + "img/horizontal_3_5_pp23_8019.6bafdbf6.png";